import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import { RulesManager } from "@/components/buildRule/RulesManager";
import { RulesVersion } from "@/components/VersionRule/RulesVersion";
import { RuleVersionHistory } from "@/components/VersionRule/RuleVersionHistory";
import { SearchResolve } from "@/components/SearchResolve";
import { DataQuality } from "@/components/DataQuality";
import { ImportExport } from "@/components/ImportExport";
import { AuditLog } from "@/components/AuditLog";
import { AIConsole } from "@/components/AIConsole";
import { Settings } from "@/components/Settings";
import NotFound from "@/pages/not-found";
import EdiTableRuleBuilder from "./components/buildRule/CreateRule";
import ModifyValue from "./components/VersionRule/ModifyValue";
import { RulesFunction } from "./components/FunctionRule/RulesFunction";
import { CreatePublishRule } from "./components/PublishRule/CreatePublishRule";
import CreateRulePrompt from "./components/AIBuilder/CreateRulePrompt";
import { useAuthMe } from "./hooks/useLocalStorage";
import { useEffect } from "react";
import { RedirectingScreen } from "./components/authentication/LoadingSpinner";


function Router() {
  return (
    <Layout>
      <Switch>
        <Route path="/" component={RulesManager} />
        <Route path="/rulefunction" component={RulesFunction} />
        <Route path="/ruleversion" component={RulesVersion} />
        <Route path="/rulepublish" component={CreatePublishRule} />
        <Route path="ruleversion/:ruleId" component={RuleVersionHistory} />
        <Route path="/rules/edit/:ruleId" component={EdiTableRuleBuilder} />
        <Route path="/version/edit/:ruleId" component={ModifyValue} />
        <Route path="/search" component={SearchResolve} />
        <Route path="/quality" component={DataQuality} />
        <Route path="/import" component={ImportExport} />
        <Route path="/audit" component={AuditLog} />
        <Route path="/ai-builder" component={CreateRulePrompt} />
        <Route path="/ai" component={AIConsole} />
        <Route path="/settings" component={Settings} />
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
}

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useAuthMe();

  useEffect(() => {
    if (isError) {
      console.log("Authentication check failed");
    }
  }, [isError]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">redirecting...</p>
        </div>
      </div>
    );
  }

  // if (data) {
  //   return <>{children}</>;
  // }

  // return (
  //   <RedirectingScreen />
  // );

  if (isError || !data) {
    return <RedirectingScreen />;
  }

  return <>{children}</>;
}

function App() {
  useAuthMe();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AuthGuard>
          <Router />
        </AuthGuard>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
